<app-page>
  <div class="corporate-registration-approvals">
    <app-page-title 
      [title]="'CORPORATE-REGISTRATION-APPROVALS.TITLE' | translate">
    </app-page-title>
    <p class="description">
      {{ 'CORPORATE-REGISTRATION-APPROVALS.DESCRIPTION' | translate }}
    </p>

    <app-panel>
      <ng-container *ngIf="registration; else noRegistration">
        <div class="registration-details">
          <div class="detail">
            <span class="label">{{ 'COMMON.FIELDS.FIRST-NAME' | translate }}</span>
            <span>{{ registration.firstName }}</span>
          </div>

          <div class="detail">
            <span class="label">{{ 'COMMON.FIELDS.LAST-NAME' | translate }}</span>
            <span>{{ registration.lastName }}</span>
          </div>

          <div class="detail">
            <span class="label">{{ 'COMMON.FIELDS.EMAIL' | translate }}</span>
            <span>{{ registration.email }}</span>
          </div>

          <div class="detail">
            <span class="label">{{ 'COMMON.FIELDS.COMPANY' | translate }}</span>
            <span>{{ registration.company }}</span>
          </div>

          <div class="detail">
            <span class="label">{{ 'COMMON.FIELDS.PHONE-MOBILE' | translate }}</span>
            <span>{{ registration.phone || '-' }}</span>
          </div>

          <div class="detail">
            <span class="label">{{ 'COMMON.FIELDS.DATE' | translate }}</span>
            <span>{{ registration.createdAt | date }}</span>
          </div>
        </div>

        <div class="actions">
          <dx-button
            [text]="'COMMON.APPROVE' | translate"
            type="normal"
            (onClick)="approve()"
          ></dx-button>

          <dx-button
            [text]="'COMMON.REJECT' | translate"
            type="default"
            (onClick)="reject()"
          ></dx-button>
        </div>
      </ng-container>

      <ng-template #noRegistration>
        <p>{{ 'CORPORATE-REGISTRATION-APPROVALS.NO-DATA' | translate }}</p>
      </ng-template>
    </app-panel>
  </div>
</app-page>